<template>
    <div class="bg-[#23242A] h-full overflow-y-auto">
        <div class="table-loading" v-if="loading">
            <block-loading />
        </div>
        <div class="p-3 custom-full custom-left" v-else-if="error"><p  class="text-center text-theme-red">No Data found.</p></div>
        <div v-else>
            <div class="pt-[16px] px-[24px] max-w-full">
                <div class="flex justify-between shadow-xl box-border items-center text-white h-[62px] rounded p-4 bg-[#2B2C32] mb-4">
                    <div class="flex items-center">
                        <svg @click="goBack" class="cursor-pointer" width="20" height="20" vie wBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 8.75H4.7875L11.775 1.7625L10 0L0 10L10 20L11.7625 18.2375L4.7875 11.25H20V8.75Z" fill="white"/>
                        </svg>
                        <h1 class="font-bold ml-3 text-2xl leading-[30px] tracking-[0.05px]">{{form.name.value}}</h1>
                    </div>
                    <div class="flex items-center" v-if="payload.status=='shipped transfer'">
                        <div class="flex items-center border-r border-[#464851] pr-4">
                            <select v-model="form.status.value" class="cursor-pointer w-[200px] h-[40px] bg-[#464851] border-[#464851] focus:outline-0 font-normal text-base leading-5 text-white p-2 rounded">
                                <option value="shipped transfer">Shipped Transfer</option>
                                <option value="completed transfer">Completed Transfer</option>
                            </select>
                        </div>
                        <div class="flex items-center pl-4">
                            <button @click="exportTransfer" :disabled="payload.status==='pending'" class="flex items-center disabled:bg-field-black disabled:text-theme-modalbg text-white bg-theme-green rounded px-4 uppercase h-[40px] mr-6">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M19 9H15V3H9V9H5L12 16L19 9ZM11 11V5H13V11H14.17L12 13.17L9.83 11H11ZM19 20V18H5V20H19Z" :class="payload.status==='pending' ? 'fill-gray-700' : 'fill-white'"/>
                                </svg>
                                <span class="text-sm">Export</span>
                            </button>
                            <button @click.prevent="goBack" class="flex justify-center items-center text-center w-[100px] h-[40px] p-4 border hover:border-theme-green text-[#9E9E9E] border-[#9E9E9E] hover:bg-theme-green hover:text-white rounded font-medium text-sm leading-[17.5px] tracking-[0.15px] mr-6">CANCEL</button>
                            <button :disabled="form.status.value==='shipped transfer'" @click.prevent="save" class="flex justify-center items-center text-center w-[100px] h-[40px] p-4 disabled:bg-theme-grey hover:opacity-60 bg-theme-green text-white rounded font-medium text-sm leading-[17.5px] tracking-[0.15px]">SAVE</button>
                        </div>
                    </div>
                </div>
            </div>
        
            <!-- Transfer details -->
            <div class=" px-[24px] max-w-full">
                <div class=" shadow-xl box-border items-center text-white rounded p-4 bg-[#2B2C32] mb-4">
                    <h2 class="font-bold  text-xl leading-6 tracking-[0.15px]">Transfer Details</h2>
                    <div class="flex gap-3 xl:flex-row flex-col items-start mt-[35px] mb-4">
                        <div class="w-full xl:w-1/2">
                            <div :class="'input-wrapper flex flex-col ' + (form.name.error_type)">
                                <label class="text-xs mb-1">Transfer Name *</label>
                                <input :disabled="$route.query.status!=='pending'" @keyup="validateFields(['name'])" v-model="form.name.value" placeholder="X-mas Quick Transfer" class="placeholder-theme-878686 h-[40px] block border-none rounded  w-full text-sm text-theme-white disabled:bg-[#1C1D21]" type="text">
                                <p class="field-error label-text mt-1" v-if="form.name.error_message" v-text="form.name.error_message"></p>
                            </div>
                        </div>
                        <div class="w-full xl:w-1/2">
                            <div :class="'input-wrapper flex flex-col ' + (form.fromLocationId.error_type)">
                                <label class="text-xs mb-1">Transfer From *</label>
                                <select  @change="validateFields(['fromLocationId'])" v-model="form.fromLocationId.value" class="pointer-events-none w-full h-[40px]  border-none focus:outline-0 font-normal text-sm leading-5 text-white p-2 rounded bg-[#1C1D21]">
                                    <option value="">Select a store</option>
                                    <option v-for="each in vg_locations" :key="each.id" :value="each.id">{{each.name}}</option>
                                </select>
                                <p class="field-error label-text mt-1" v-if="form.fromLocationId.error_message" v-text="form.fromLocationId.error_message"></p>
                            </div>
                        </div>
                        <div class="w-full xl:w-1/2">
                            <div :class="'input-wrapper flex flex-col ' + (form.toLocationId.error_type)">
                                <label class="text-xs mb-1">Transfer To *</label>
                                <select  @change="validateFields(['toLocationId'])" v-model="form.toLocationId.value" class="pointer-events-none w-full h-[40px]  border-none focus:outline-0 font-normal text-sm leading-5 text-white p-2 rounded bg-[#1C1D21]">
                                    <option value="">Select a store</option>
                                    <template v-for="each in vg_locations">
                                        <option v-if="each.id!==form.fromLocationId.value" :key="each.id" :value="each.id">{{each.name}}</option>
                                    </template>
                                </select>
                                <p class="field-error label-text mt-1" v-if="form.toLocationId.error_message" v-text="form.toLocationId.error_message"></p>
                            </div>
                        </div>
                        <div class="w-full xl:w-1/2">
                            <div class="input-wrapper flex flex-col ">
                                <p class="text-xs mb-1">Created On</p>
                                <div class="relative">
                                    <div class="absolute px-2 top-[10px]">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 11.667C9.76389 11.667 9.56597 11.5871 9.40625 11.4274C9.24653 11.2677 9.16667 11.0698 9.16667 10.8337C9.16667 10.5975 9.24653 10.3996 9.40625 10.2399C9.56597 10.0802 9.76389 10.0003 10 10.0003C10.2361 10.0003 10.434 10.0802 10.5937 10.2399C10.7535 10.3996 10.8333 10.5975 10.8333 10.8337C10.8333 11.0698 10.7535 11.2677 10.5937 11.4274C10.434 11.5871 10.2361 11.667 10 11.667ZM6.66667 11.667C6.43056 11.667 6.23264 11.5871 6.07292 11.4274C5.91319 11.2677 5.83333 11.0698 5.83333 10.8337C5.83333 10.5975 5.91319 10.3996 6.07292 10.2399C6.23264 10.0802 6.43056 10.0003 6.66667 10.0003C6.90278 10.0003 7.10069 10.0802 7.26042 10.2399C7.42014 10.3996 7.5 10.5975 7.5 10.8337C7.5 11.0698 7.42014 11.2677 7.26042 11.4274C7.10069 11.5871 6.90278 11.667 6.66667 11.667ZM13.3333 11.667C13.0972 11.667 12.8993 11.5871 12.7396 11.4274C12.5799 11.2677 12.5 11.0698 12.5 10.8337C12.5 10.5975 12.5799 10.3996 12.7396 10.2399C12.8993 10.0802 13.0972 10.0003 13.3333 10.0003C13.5694 10.0003 13.7674 10.0802 13.9271 10.2399C14.0868 10.3996 14.1667 10.5975 14.1667 10.8337C14.1667 11.0698 14.0868 11.2677 13.9271 11.4274C13.7674 11.5871 13.5694 11.667 13.3333 11.667ZM10 15.0003C9.76389 15.0003 9.56597 14.9205 9.40625 14.7607C9.24653 14.601 9.16667 14.4031 9.16667 14.167C9.16667 13.9309 9.24653 13.733 9.40625 13.5732C9.56597 13.4135 9.76389 13.3337 10 13.3337C10.2361 13.3337 10.434 13.4135 10.5937 13.5732C10.7535 13.733 10.8333 13.9309 10.8333 14.167C10.8333 14.4031 10.7535 14.601 10.5937 14.7607C10.434 14.9205 10.2361 15.0003 10 15.0003ZM6.66667 15.0003C6.43056 15.0003 6.23264 14.9205 6.07292 14.7607C5.91319 14.601 5.83333 14.4031 5.83333 14.167C5.83333 13.9309 5.91319 13.733 6.07292 13.5732C6.23264 13.4135 6.43056 13.3337 6.66667 13.3337C6.90278 13.3337 7.10069 13.4135 7.26042 13.5732C7.42014 13.733 7.5 13.9309 7.5 14.167C7.5 14.4031 7.42014 14.601 7.26042 14.7607C7.10069 14.9205 6.90278 15.0003 6.66667 15.0003ZM13.3333 15.0003C13.0972 15.0003 12.8993 14.9205 12.7396 14.7607C12.5799 14.601 12.5 14.4031 12.5 14.167C12.5 13.9309 12.5799 13.733 12.7396 13.5732C12.8993 13.4135 13.0972 13.3337 13.3333 13.3337C13.5694 13.3337 13.7674 13.4135 13.9271 13.5732C14.0868 13.733 14.1667 13.9309 14.1667 14.167C14.1667 14.4031 14.0868 14.601 13.9271 14.7607C13.7674 14.9205 13.5694 15.0003 13.3333 15.0003ZM3.75 18.3337C3.41667 18.3337 3.125 18.2087 2.875 17.9587C2.625 17.7087 2.5 17.417 2.5 17.0837V4.16699C2.5 3.83366 2.625 3.54199 2.875 3.29199C3.125 3.04199 3.41667 2.91699 3.75 2.91699H5.10417V1.66699H6.45833V2.91699H13.5417V1.66699H14.8958V2.91699H16.25C16.5833 2.91699 16.875 3.04199 17.125 3.29199C17.375 3.54199 17.5 3.83366 17.5 4.16699V17.0837C17.5 17.417 17.375 17.7087 17.125 17.9587C16.875 18.2087 16.5833 18.3337 16.25 18.3337H3.75ZM3.75 17.0837H16.25V8.12533H3.75V17.0837ZM3.75 6.87533H16.25V4.16699H3.75V6.87533ZM3.75 6.87533V4.16699V6.87533Z" fill="white"/>
                                        </svg>
                                    </div>
                                    <input v-model="form.createdAt.value" :disabled="true" placeholder="12/04/2023" class="text-white placeholder:text-white pointer-events-none pl-[35px] h-[40px] block border-none rounded  w-full text-sm  bg-[#1C1D21]">
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div class="flex gap-3 xl:flex-row flex-col items-start mt-[35px] mb-4">
                        <div class="w-full xl:w-1/4">
                            <div :class="'input-wrapper flex flex-col' ">
                                <label class="text-xs mb-1">ETA (optional)</label>
                                <Datepicker  inputFormat="yyyy-MM-dd" :disabled="$route.query.status!=='pending'" v-model="form.eta.value" class="text-sm text-white placeholder:text-white border-0 h-9 w-full rounded disabled:bg-[#1C1D21]" placeholder="-" />
                            </div>
                        </div>
                        <div v-if="$route.query.status==='completed'" class="w-full xl:w-1/4">
                            <div class="input-wrapper flex flex-col ">
                                <p class="text-xs mb-1">Completed On</p>
                                <div class="relative">
                                    <div class="absolute px-2 top-[10px]">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 11.667C9.76389 11.667 9.56597 11.5871 9.40625 11.4274C9.24653 11.2677 9.16667 11.0698 9.16667 10.8337C9.16667 10.5975 9.24653 10.3996 9.40625 10.2399C9.56597 10.0802 9.76389 10.0003 10 10.0003C10.2361 10.0003 10.434 10.0802 10.5937 10.2399C10.7535 10.3996 10.8333 10.5975 10.8333 10.8337C10.8333 11.0698 10.7535 11.2677 10.5937 11.4274C10.434 11.5871 10.2361 11.667 10 11.667ZM6.66667 11.667C6.43056 11.667 6.23264 11.5871 6.07292 11.4274C5.91319 11.2677 5.83333 11.0698 5.83333 10.8337C5.83333 10.5975 5.91319 10.3996 6.07292 10.2399C6.23264 10.0802 6.43056 10.0003 6.66667 10.0003C6.90278 10.0003 7.10069 10.0802 7.26042 10.2399C7.42014 10.3996 7.5 10.5975 7.5 10.8337C7.5 11.0698 7.42014 11.2677 7.26042 11.4274C7.10069 11.5871 6.90278 11.667 6.66667 11.667ZM13.3333 11.667C13.0972 11.667 12.8993 11.5871 12.7396 11.4274C12.5799 11.2677 12.5 11.0698 12.5 10.8337C12.5 10.5975 12.5799 10.3996 12.7396 10.2399C12.8993 10.0802 13.0972 10.0003 13.3333 10.0003C13.5694 10.0003 13.7674 10.0802 13.9271 10.2399C14.0868 10.3996 14.1667 10.5975 14.1667 10.8337C14.1667 11.0698 14.0868 11.2677 13.9271 11.4274C13.7674 11.5871 13.5694 11.667 13.3333 11.667ZM10 15.0003C9.76389 15.0003 9.56597 14.9205 9.40625 14.7607C9.24653 14.601 9.16667 14.4031 9.16667 14.167C9.16667 13.9309 9.24653 13.733 9.40625 13.5732C9.56597 13.4135 9.76389 13.3337 10 13.3337C10.2361 13.3337 10.434 13.4135 10.5937 13.5732C10.7535 13.733 10.8333 13.9309 10.8333 14.167C10.8333 14.4031 10.7535 14.601 10.5937 14.7607C10.434 14.9205 10.2361 15.0003 10 15.0003ZM6.66667 15.0003C6.43056 15.0003 6.23264 14.9205 6.07292 14.7607C5.91319 14.601 5.83333 14.4031 5.83333 14.167C5.83333 13.9309 5.91319 13.733 6.07292 13.5732C6.23264 13.4135 6.43056 13.3337 6.66667 13.3337C6.90278 13.3337 7.10069 13.4135 7.26042 13.5732C7.42014 13.733 7.5 13.9309 7.5 14.167C7.5 14.4031 7.42014 14.601 7.26042 14.7607C7.10069 14.9205 6.90278 15.0003 6.66667 15.0003ZM13.3333 15.0003C13.0972 15.0003 12.8993 14.9205 12.7396 14.7607C12.5799 14.601 12.5 14.4031 12.5 14.167C12.5 13.9309 12.5799 13.733 12.7396 13.5732C12.8993 13.4135 13.0972 13.3337 13.3333 13.3337C13.5694 13.3337 13.7674 13.4135 13.9271 13.5732C14.0868 13.733 14.1667 13.9309 14.1667 14.167C14.1667 14.4031 14.0868 14.601 13.9271 14.7607C13.7674 14.9205 13.5694 15.0003 13.3333 15.0003ZM3.75 18.3337C3.41667 18.3337 3.125 18.2087 2.875 17.9587C2.625 17.7087 2.5 17.417 2.5 17.0837V4.16699C2.5 3.83366 2.625 3.54199 2.875 3.29199C3.125 3.04199 3.41667 2.91699 3.75 2.91699H5.10417V1.66699H6.45833V2.91699H13.5417V1.66699H14.8958V2.91699H16.25C16.5833 2.91699 16.875 3.04199 17.125 3.29199C17.375 3.54199 17.5 3.83366 17.5 4.16699V17.0837C17.5 17.417 17.375 17.7087 17.125 17.9587C16.875 18.2087 16.5833 18.3337 16.25 18.3337H3.75ZM3.75 17.0837H16.25V8.12533H3.75V17.0837ZM3.75 6.87533H16.25V4.16699H3.75V6.87533ZM3.75 6.87533V4.16699V6.87533Z" fill="white"/>
                                        </svg>
                                    </div>
                                    <input placeholder="12/04/2023" class="pointer-events-none pl-[35px] h-[40px] block border-none rounded  w-full placeholder:text-white text-sm text-theme-white disabled:bg-[#1C1D21]">
                                </div>
                            </div>
                        </div>
                        <div v-else class="w-full xl:w-1/4"></div>
                        <div class="w-full xl:w-1/4"></div>
                        <div class="w-full xl:w-1/4"></div>
                    </div>
                    <div class="flex xl:flex-row flex-col items-start mt-[35px] mb-4">
                        <div class="w-full ">
                            <div :class="'input-wrapper flex flex-col' ">
                                <label class="text-xs mb-1">Notes (optional)</label>
                                <textarea  v-model="form.note.value" placeholder="-" class="placeholder:text-white pointer-events-none block border-none rounded  w-full text-sm text-white bg-[#1C1D21]" ></textarea>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Selected products -->
            <div class=" px-[24px] max-w-full mb-20">
                <div class="flex flex-col  shadow-xl box-border px-4 text-white  rounded py-4 bg-[#2B2C32] mb-4">
                    <h2 class="font-bold  ml-3 text-xl leading-6 mb-11 tracking-[0.15px]">Selected Products ({{activeProducts.length}})</h2>

                    <ProductList :status="form.status.value" :products="activeProducts" :selected="selected" />
                </div>
            </div>
        </div>
        <Warning :status="invalidPopup" @close="invalidPopup=false" />
    </div>
</template>
<script>
import {defineComponent, ref} from "vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import Helpers from '@/helpers';
import { useSnackbar } from "vue3-snackbar";
import TransferApi from '@/controllers/Transfer'
import ProductList from "@/views/Inventory/Transfer/receive/ProductList.vue"
import Datepicker from 'vue3-datepicker'
import moment from 'moment'
import Warning from '@/views/Inventory/Transfer/receive/Warning.vue'
import TransferHelper from '@/helpers/transfer'

export default defineComponent({
  name: "ReceiveInventoryTransfer",
  components: {
    Datepicker,
    ProductList,
    Warning
  },

  setup() {
    const loading = ref(false)
    const error =ref(false)
    const invalidPopup = ref(false)
    const snackbar = useSnackbar();
    const action = ref({
      component: '',
      data: [],
    });
    const payload = ref({transferProducts:[]})
    const form = ref({
      name: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3'],
      },
      fromLocationId: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      toLocationId: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      eta: {
        value: null
      },
      note: {
        value: ''
      },
      status: {
        value: 'shipped'
      },
       createdAt: {
        value: ''
      }
    });
    const variantInfo = ref(true)
    const lotInfo =ref(true)
    const selected = ref([])
    const activeProducts = ref([])

    return {
      loading,
      error,
      invalidPopup,
      form,
      payload,
      snackbar,
      action,
      variantInfo,
      lotInfo,
      selected,
      activeProducts
    };
  },

  computed: {
    /**
     * Edit restriction
     */
    can_edit_membership_details() {
      return Helpers.getMyPermission('can_edit_membership_details')
    },
    ...mapGetters({
        vg_locations: 'location/list',
        vg_selectedLocation: 'location/selected',
    }),
  },

  async mounted() {
    this.error = false
    if(this.$route.params.id && this.$route.query.locationId){
        this.form.status.value = 'shipped transfer'
        this.loading = true
        await this.getData()
        this.loading = false
    }else{
        this.error = true
    }
  },

  watch: {
    'vg_selectedLocation'(val) {
      this.$router.push('/inventory-transfer')
    },
    "form.fromLocationId.value"(val){
        if(val===this.form.toLocationId.value){
            this.form.toLocationId.value = ''
        }
    },
  },

  methods: {
      formatDate(date){
        if(!date) return
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
    },
    async getData(){
        let res = await TransferApi.getTransfer(this.$route.params.id, this.$route.query.locationId, this.$route.query.toLocationId)
        if(res.data?.payload){
            this.payload = res.data.payload
            this.form.name.value = this.payload.name
            this.form.fromLocationId.value = this.payload.fromLocationId
            this.form.toLocationId.value = this.payload.toLocationId
            this.form.eta.value = this.payload.eta?new Date(this.payload.eta):null
            this.form.note.value = this.payload.note
            this.form.createdAt.value = this.payload.createdAt?this.formatDate(this.payload.createdAt):null

            // get activeProducts: enabled 
            this.activeProducts = []
            this.getActiveProducts(this.payload.transferProducts)

            // add selected product in list
            for(let i=0; i<this.payload.transferProducts.length; i++){

                // get main variant
                this.loadTransferQty(this.payload.transferProducts[i])

                // get sub variant
                for(let j=0; j<this.payload.transferProducts[i].transferVariants.length; j++){
                    this.loadTransferQty(this.payload.transferProducts[i].transferVariants[j])
                }
            }
        }else{
            this.error = true
        }
    },
    getActiveProducts(products){
      for(let i=0; i<products.length; i++){
        let allBatchesInactive = false
        let allSubVariantInActive = false
        if(products[i].transferBatches.length>0){
            // show product if some batch is selected
            allBatchesInactive = products[i].transferBatches.some(each => each.isSelected)
        }else{
            allBatchesInactive = true
        }
        if(products[i].transferVariants.length>0){
            // show product if some variant some batch is selected
            allSubVariantInActive = products[i].transferVariants.some(variant => variant.transferBatches.some(each => each.isSelected))
        }else{
            allSubVariantInActive = true
        }

        if(allBatchesInactive || allSubVariantInActive){
            this.activeProducts.push(products[i])
        }
      }
    },
    // add to selected if transferQty > 0
    loadTransferQty(product){
        if(product.transferBatches.length>0){
            // have batch
            let batches= []
            let sumQty = 0
            for(let j=0; j<product.transferBatches.length; j++){
                if(product.transferBatches[j].transferQty>0){
                    batches.push({
                        transferBatchId: product.transferBatches[j].id,
                        transferQty: product.transferBatches[j].transferQty,
                        actualTransferQty: product.transferBatches[j].transferQty
                    })
                    sumQty += product.transferBatches[j].transferQty
                }
            }
            if(sumQty>0){
                this.selected.push({
                    transferProductId: product.id,
                    transferQty: product.transferQty,
                    actualTransferQty: product.transferQty,
                    batches: batches
                })
            }
        }else{
            // no batch
            if(product.transferQty>0){
                this.selected.push({
                    transferProductId: product.id,
                    transferQty: product.transferQty,
                    actualTransferQty: product.transferQty,
                })
            }
        }
    },
    goBack(){
        this.$router.push('/inventory-transfer')
    },
    clearComponent() {
      this.action = {
        component: '',
        data: [],
      };
      let activeItem = document.getElementsByClassName('active-row');
      if(activeItem.length > 0){
        activeItem[0].classList.remove("active-row");
        let subGroup = document.getElementsByClassName('active-sub-row')
        Array.from(subGroup).forEach((item) => {
          item.classList.remove('active-sub-row')
        })
      }
    },
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      this.form = res.data;
      return res.error ? false : true;
    },
    async save(){
        if(this.form.status.value==='completed transfer'){
            this.confirmNew('Adjust Product Inventory', 'This action cannot be undone. Are you sure you want to continue?').then(async () => {
                let selectedFromLocation = this.vg_locations.find(each => each.id===this.form.fromLocationId.value)
                let selectedToLocation = this.vg_locations.find(each => each.id===this.form.toLocationId.value)
                let etaDate = this.form.eta.value?moment(this.form.eta.value).format('YYYY-MM-DD'):null
                let data = {
                    name: this.form.name.value,
                    fromLocationId: this.form.fromLocationId.value,
                    fromLocationName: selectedFromLocation?selectedFromLocation.name:'',
                    toLocationId: this.form.toLocationId.value,
                    toLocationName: selectedToLocation?selectedToLocation.name:'',
                    status: this.form.status.value,
                    eta: etaDate,
                    note: this.form.note.value,
                        
                }
                this.va_spinner(true)
                // let res = await TransferApi.bulkUpdate({transferId: this.payload.id, transferProducts: this.selected})
                let res = await TransferApi.updateTransfer(this.payload.id, data)
                this.va_spinner(false)
                this.snackbar.add({
                    type: 'info',
                    text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                    duration: 3000,
                })

                if(res.status===200){
                    this.$router.push('/inventory-transfer')
                }
            })
        }else{
            this.snackbar.add({
                type: 'info',
                text: "Please change status",
                duration: 3000,
            })
            this.va_spinner(false)
        }
    },
    async exportTransfer(){
      try{
            let data = await TransferHelper.getTransferExportRows(this.payload.transferProducts)
            let fileName = `transfer-${this.payload.name}.xlsx`
            await TransferHelper.exportTransfer(fileName, data)
            let self = this
            setTimeout(function(){
                self.snackbar.add({
                type: 'info',
                text: 'File downloaded',
                duration: 3000,
                })
            }, 1000)
        } catch(err) {
            return this.snackbar.add({
                type: 'info',
                text: 'Something went wrong. Please try again later.',
                duration: 3000,
            })
        }
    },
    ...mapActions({
      va_spinner: "spinner/setSpinner",
    })
  },
});

</script>
<style>
.v3dp__datepicker{
    display: flex;
    flex-direction: row;
}
</style>
